import { getElements } from 'js-utils/src/selector';
import VimeoPlayer from '@vimeo/player';
import _ from 'underscore';
import init from '../base/init';

init(() => {
  let video = document.getElementsByClassName("live-seminar-video-player");
  // if(!video.length) return;

  video = video[0];
  const player = document.querySelector('.live-seminar-video-player');
  const frame = getElements('.live-seminar-video-player iframe')[0];
  if(!frame) return;

  const vimeoPlayer = new VimeoPlayer(frame);
  const available_to_user = window.LEXNOVA.aet.props.available_to_user === "true";

  vimeoPlayer.setColor('#d61368');

  vimeoPlayer.on('ended', () => {
    videoEvent({ event: 'ended' });
    player.classList.remove('video-player--overlay-hidden');
    player.classList.remove('video-player--playing');
  });

  vimeoPlayer.on('play', () => {
    videoEvent({ event: 'play' });
    player.classList.add('video-player--playing');

    window.dispatchEvent(new CustomEvent('AET', {detail: {
      name: `${window.LEXNOVA.section_name}.seminar_play`,
      props: window.LEXNOVA.aet.props
    }}));
  });

  vimeoPlayer.on('pause', (data) => {
    videoEvent({ event: 'pause', seconds: data.seconds });
    player.classList.remove('video-player--playing');
  });

  vimeoPlayer.on('timeupdate', (data) => {
    videoEvent({ event: 'progress', seconds: data.seconds });
  });

  const fireVideoEvent = (dataObject) => {
    // User#do_not_track must be set to false
    if (available_to_user) {
      fetch('/api/v1/seminar_playbacks/' + video.getAttribute('data-video-resource-id'), {
        method: "PATCH",
        credentials: 'same-origin',
        headers: {
          'Content-Type': 'application/json; charset=utf-8',
        },
        body: JSON.stringify(dataObject),
      });
    }
  };

  const videoEvent = _.throttle(
    fireVideoEvent, 5.0 * 1000
  );
});
